<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <supplier-form v-if="orderEmailText !== null" @submit="submit"
          :init-supplier="{ min_order_sum: '', country: 'Österreich', order_email_text: orderEmailText }"
          :val-errors="valErrors" submit-text="Erstellen" />
      </card>
    </div>
  </div>
</template>

<script>
import SupplierForm from './supplier-form'
import swal from 'sweetalert2'

export default {
  components: { SupplierForm },
  data() {
    return {
      valErrors: [],
      orderEmailText: null
    }
  },
  methods: {
    async submit(supplier) {
      await this.initCsrf()

      this.valErrors = []
      this.$http.post('suppliers', supplier).then(({ data }) => {
        this.$notify({
          message: 'Lieferant erfolgreich erstellt.',
          type: 'success'
        })
        this.showAlert(data)
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    },
    showAlert(createdSupplier) {
      swal.fire({
        title: 'Ansprechpartner',
        html: 'Wollen Sie jetzt Ansprechpartner anlegen?',
        confirmButtonText: 'Ja bitte!',
        showCancelButton: true,
        cancelButtonText: 'Nein danke!',
        timer: 2500,
        timerProgressBar: true,
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-lg btn-fill btn-info',
        cancelButtonClass: 'btn btn-lg btn-fill btn-default'
      }).then((result) => {
        if (result.value === true) {
          this.$router.push(`/suppliers/${createdSupplier.id}/contact_people/create`)
        } else {
          this.$router.push('/suppliers')
        }
      })
    },
  },

  async created() {
    try {
      const { data } = await this.$http.get('/settings');

      if (data.order_email_supplier_text) {
        this.orderEmailText = `${data.order_email_supplier_text}`;
      } else {
        this.orderEmailText = '';
      }

    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  },

}
</script>

<style></style>
